import { render, staticRenderFns } from "./SDGContributions.vue?vue&type=template&id=1f39659c&"
import script from "./SDGContributions.vue?vue&type=script&lang=js&"
export * from "./SDGContributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports